import { render } from "./AllTicketsHandleWaiting.vue?vue&type=template&id=6f6a9076&scoped=true&ts=true"
import script from "./AllTicketsHandleWaiting.vue?vue&type=script&lang=ts"
export * from "./AllTicketsHandleWaiting.vue?vue&type=script&lang=ts"

import "./AllTicketsHandleWaiting.vue?vue&type=style&index=0&id=6f6a9076&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6a9076"]])

export default __exports__